import { createContext } from 'react';

export type SidenavSlot = {
  // Where the layout wants the desktop side menu to live. `null` while the layout has mounted but
  // its element is not ready yet.
  element: HTMLElement | null;
  // Lets the layout know a side menu is docked in the slot, so it can drop its own logo.
  setDocked: (docked: boolean) => void;
};

// Without a provider (tests, stories) the side menu renders where it is declared.
export const SidenavSlotContext = createContext<SidenavSlot | undefined>(undefined);
